import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=5c3eb00a&scoped=true"
import script from "./Tenant.vue?vue&type=script&lang=js"
export * from "./Tenant.vue?vue&type=script&lang=js"
import style0 from "./Tenant.vue?vue&type=style&index=0&id=5c3eb00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3eb00a",
  null
  
)

export default component.exports